import {
  GET,
  FOR_SUBMIT,
  UPDATE,
  RESET,
  EXPORT_EXCEL
} from '@hobs/constants/transportation';
import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { actionCreator } from './utils/utils';

export const forSubmit = () =>
  actionCreator('Transportation/ForSubmit', FOR_SUBMIT, {
    method: 'GET'
  });

export const get = serviceRequestId =>
  actionCreator(`Transportation/${serviceRequestId}`, GET, {
    method: 'GET'
  });

export const reset = () => {
  return dispatch => {
    dispatch({ type: RESET.SUCCESS });
  };
};

export const update = (serviceRequestId, body) =>
  actionCreator(`Transportation/${serviceRequestId}`, UPDATE, {
    method: 'PUT',
    body
  });

export const exportExcel = serviceRequestId => {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`Transportation/${serviceRequestId}/Excel`, {
      method: 'GET',
      forceBlob: true
    })
      .then(response => {
        dispatch(success());
        return response;
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EXPORT_EXCEL.REQUEST };
  }
  function success(response) {
    return { type: EXPORT_EXCEL.SUCCESS, response };
  }
  function failure(error) {
    return { type: EXPORT_EXCEL.FAILURE, error };
  }
};
